import * as z from "zod";
export const Icon = z.union([z.literal("CHECK"), z.literal("CROSS")]);
